import types from './types';

const InitialState = {
    loaded: false,
    level: "regular",
    level_preset: null,
    tags: {
        loss_shield: 0,
        crypto_multiplier: 0
    },
    xp: 0,
    bonuses: {
        freeplay: {},
        weekly_rakeback: {},
        random_boost: {},
        monthly_rakeback: {}
    },
    buttons: {
        freeplay: false,
        birthday_bonus: false
    }
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.bonuses.monthly_rakeback:
            return {
                ...state,
                monthly_rakeback: {
                    ...payload,
                    progress: {
                        from: payload.progress.from + Date.now(),
                        to: payload.progress.to + Date.now()
                    },
                    cooldown_timestamp: payload.cooldown_timestamp + Date.now()
                }
            }
        case types.bonuses.weekly_rakeback:
            return {
                ...state,
                weekly_rakeback: {
                    ...payload,
                    progress: {
                        from: payload.progress.from + Date.now(),
                        to: payload.progress.to + Date.now()
                    },
                    cooldown_timestamp: payload.cooldown_timestamp + Date.now()
                }
            }
        case types.bonuses.birthday_bonus:
            return {
                ...state,
                bonuses: {
                    birthday_bonus: {
                        ...payload,
                        cooldown_timestamp: payload.cooldown_timestamp + Date.now()
                    },
                }
            }
        case types.bonuses.freeplay:
            return {
                ...state,
                bonuses: {
                    freeplay: {
                        ...payload,
                        cooldown_timestamp: payload.cooldown_timestamp + Date.now()
                    }
                }
            }
        case types.toggleButton:
            return {
                ...state,
                buttons: {
                    ...state.buttons,
                    [payload]: !state.buttons[payload]
                }
            }
        case types.loaded:
            return {
                ...state,
                loaded: true,
                level: payload.level,
                level_preset: payload.level_preset,
                tags: payload.tags,
                xp: payload.xp,
                bonuses: {
                    freeplay: {
                        ...payload.bonuses.freeplay,
                        cooldown_timestamp: payload.bonuses.freeplay.cooldown_timestamp + Date.now()
                    },
                    birthday_bonus: {
                        ...payload.bonuses.birthday_bonus,
                        cooldown_timestamp: payload.bonuses.birthday_bonus.cooldown_timestamp + Date.now()
                    },
                    weekly_rakeback: {
                        ...payload.bonuses.weekly_rakeback,
                        progress: {
                            from: payload.bonuses.weekly_rakeback.progress.from + Date.now(),
                            to: payload.bonuses.weekly_rakeback.progress.to + Date.now()
                        },
                        cooldown_timestamp: payload.bonuses.weekly_rakeback.cooldown_timestamp + Date.now()
                    },
                    monthly_rakeback: {
                        ...payload.bonuses.monthly_rakeback,
                        progress: {
                            from: payload.bonuses.monthly_rakeback.progress.from + Date.now(),
                            to: payload.bonuses.monthly_rakeback.progress.to + Date.now()
                        },
                        cooldown_timestamp: payload.bonuses.monthly_rakeback.cooldown_timestamp + Date.now()
                    }
                }
            }
        default:
            return state;
    }
}